module.exports = __webpack_public_path__ + "img/video-section-bg.png";


//////////////////
// WEBPACK FOOTER
// ./img/video-section-bg.png
// module id = 237
// module chunks = 0